import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import QS from 'qs'
import testData from "./testData";
import xlooLib from "../xlooLib/xlooLib"
//import moment from "moment-timezone";



Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(QS)
Vue.use(testData);
Vue.use(xlooLib);

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {},
    state: {
        visiblePage: 'home',

        timeZoneLead: null,
        timeZoneLeadBanner: null,
        timeZoneUser: null,

        hash: null,
        firstNameUser: null,
        lastNameUser: null,

        pageTitle: 'AuctionStreaming',
        pageDescription: 'Welcome to my scheduling page. Please follow the instruction to add on event to my calendar',
        pageName: null,
        faviconPath: null,


        workHours: {},
        arrBlockedDate: {},
        meetingDuration: 60,
        breakDuration: 15,
        blockXDaysToMeetings: 0,

        storeWorkedTime: {},
        dateBooking: null,
        idMeeting:null,

        descriptionMeeting: null,

    },
    mutations: {
        set_visiblePage: (state, payload)=>{
            state.visiblePage = payload;
        },
        set_timeZoneLead: (state, payload)=>{
            state.timeZoneLead = payload;
        },
        set_timeZoneLeadBanner: (state, payload)=>{
            state.timeZoneLeadBanner = payload;
        },
        set_timeZoneUser: (state, payload)=>{
            state.timeZoneUser = payload;
        },
        set_hash: (state, payload)=>{
            state.hash = payload;
        },
        set_firstNameUser: (state, payload)=>{
            state.firstNameUser = payload;
        },
        set_lastNameUser: (state, payload)=>{
            state.lastNameUser = payload;
        },
        set_pageTitle: (state, payload)=>{
            state.pageTitle = payload;
        },
        set_pageDescription: (state, payload)=>{
            state.pageDescription = payload;
        },
        set_workHours: (state, payload)=>{
            state.workHours = payload;
        },
        set_arrBlockedDate: (state, payload)=>{
            state.arrBlockedDate = payload;
        },
        set_meetingDuration: (state, payload)=>{
            state.meetingDuration = payload;
        },
        set_breakDuration: (state, payload)=>{
            state.breakDuration = payload;
        },
        set_blockXDaysToMeetings: (state, payload)=>{
            state.blockXDaysToMeetings = payload;
        },
        set_pageName: (state, payload)=>{
            state.pageName = payload;
        },
        set_faviconPath: (state, payload)=>{
            state.faviconPath = payload;
        },
        set_storeWorkedTime: (state, payload)=>{
            state.storeWorkedTime = payload;
        },
        set_dateBooking: (state, payload)=>{
            state.dateBooking = payload;
        },
        set_idMeeting: (state, payload)=>{
            state.idMeeting = payload;
        },
        set_descriptionMeeting: (state, payload)=>{
            state.descriptionMeeting = payload;
        },
    },
    actions: {
        set_firstStep: async (context, payload) => {
            // eslint-disable-next-line no-unused-vars
            const setFirstStep = '/index.php?entryPoint=booking&action=index&hash=' + payload.hash
                + '&month=' + payload.month
                + '&year=' + payload.year
                + '&dateLink=' + payload.dateLink;
            try {
                const request_firstStep = await axios.post(setFirstStep);
                                // eslint-disable-next-line no-unused-vars
/*
                                const request_firstStep = await new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        console.log('Test FirstStep -->', testData.firstStepData);
                                        return resolve(testData.firstStepData)}, 2000)
                                });
*/
                console.log('request_firstStep.data.checkLink', request_firstStep.data.checkLink, ' request_firstStep.data.description ', request_firstStep.data.description)

                if(typeof request_firstStep.data.pageName !== 'undefined') context.commit('set_pageName', request_firstStep.data.pageName);
                if(typeof request_firstStep.data.faviconPath !== 'undefined')context.commit('set_faviconPath', request_firstStep.data.faviconPath);

                if(request_firstStep.data.crashLink){
                    console.log('in if request_firstStep.data.checkLink', request_firstStep.data.checkLink, ' in if request_firstStep.data.description ', request_firstStep.data.description)

                    return {
                        result: false,
                        description: request_firstStep.data.description || '',
                    }
                }


                if(typeof request_firstStep.data.timeZone !== 'undefined') context.commit('set_timeZoneUser', xlooLib.crmFormatToZFormat(request_firstStep.data.timeZone));
                if(typeof request_firstStep.data.firstName !== 'undefined') context.commit('set_firstNameUser', request_firstStep.data.firstName);
                if(typeof request_firstStep.data.lastName !== 'undefined') context.commit('set_lastNameUser', request_firstStep.data.lastName);

                if(typeof request_firstStep.data.arrBlockedDate !== 'undefined') context.commit('set_arrBlockedDate', xlooLib.createStoreBlockedDate(context.getters.arrBlockedDate, request_firstStep.data.arrBlockedDate));

                if(typeof request_firstStep.data.workHours !== 'undefined') context.commit('set_workHours', request_firstStep.data.workHours);
                if(typeof request_firstStep.data.titlePage !== 'undefined') context.commit('set_pageTitle', request_firstStep.data.titlePage);
                if(typeof request_firstStep.data.descriptionPage !== 'undefined') context.commit('set_pageDescription', request_firstStep.data.descriptionPage);

                if(typeof request_firstStep.data.meetingDuration !== 'undefined') context.commit('set_meetingDuration', request_firstStep.data.meetingDuration);
                if(typeof request_firstStep.data.breakDuration !== 'undefined') context.commit('set_breakDuration', request_firstStep.data.breakDuration);
                if(typeof request_firstStep.data.block_x_days_to_meetings !== 'undefined') context.commit('set_blockXDaysToMeetings', request_firstStep.data.block_x_days_to_meetings);

                const disWorkedTime = xlooLib.workedTime( context.getters.storeWorkedTime, context.getters.arrBlockedDate, context.getters.workHours, context.getters.timeZoneUser, context.getters.timeZoneLead, payload.month, payload.year, context.getters.meetingDuration, context.getters.breakDuration );

                context.commit('set_storeWorkedTime', disWorkedTime);
            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
            let monthNext= payload.month;
            let yearNext= payload.year;
            if (12 === Number(monthNext)) {
                monthNext = 1;
                yearNext++;
            } else {
                monthNext++;
            }
            // eslint-disable-next-line no-unused-vars
            const calendar_data = '/index.php?entryPoint=booking&action=Calendar&hash=' + payload.hash + '&month=' + monthNext + '&year=' + yearNext;
            try {
                const request_calendar = await axios.get(calendar_data);
/*
                // eslint-disable-next-line no-unused-vars
                const request_calendar = await new Promise((resolve, reject) => {
                    setTimeout(() => {
                        console.log('Calendar data FirstStep -->', testData.calendar_data);
                        return resolve(testData.calendar_data)}, 1000);
                });
*/
                const arrBlockedDateNextMonth = xlooLib.createStoreBlockedDate(context.getters.arrBlockedDate, request_calendar.data);
                if(typeof arrBlockedDateNextMonth !== 'undefined') context.commit('set_arrBlockedDate', arrBlockedDateNextMonth);

                const disWorkedTime = xlooLib.workedTime( context.getters.storeWorkedTime, context.getters.arrBlockedDate, context.getters.workHours, context.getters.timeZoneUser, context.getters.timeZoneLead, monthNext, yearNext, context.getters.meetingDuration, context.getters.breakDuration );

                context.commit('set_storeWorkedTime', disWorkedTime);
                return {
                    result: true,
                    description: 'Ok',
                }
            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
        },
        set_calendar: async function(context, payload) {
            // eslint-disable-next-line no-unused-vars
            const calendar_data = '/index.php?entryPoint=booking&action=Calendar&hash=' + payload.hash + '&month=' + payload.month + '&year=' + payload.year;
            try {

                const request_calendar = await axios.get(calendar_data);

                const arrBlockedDateNextMonth = xlooLib.createStoreBlockedDate(context.getters.arrBlockedDate, request_calendar.data);
                if(typeof arrBlockedDateNextMonth !== 'undefined') context.commit('set_arrBlockedDate', arrBlockedDateNextMonth);

                const disWorkedTime = xlooLib.workedTime( context.getters.storeWorkedTime, context.getters.arrBlockedDate, context.getters.workHours, context.getters.timeZoneUser, context.getters.timeZoneLead, payload.month, payload.year, context.getters.meetingDuration, context.getters.breakDuration );

                context.commit('set_storeWorkedTime', disWorkedTime);
 //               console.log(' payload.year', payload.year, ' payload.month', payload.month,  Number(payload.year + payload.month));

            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
        },
        set_preliminaryBooking: async function(context, payload) {
            const setPreliminaryBooking = '/index.php?entryPoint=booking&action=preliminaryBooking&hash=' + payload.hash +
                '&date=' + payload.date +
                '&time=' + payload.time;
            try {
                const res_setPreliminaryBooking = await axios.post(setPreliminaryBooking);
                if(typeof res_setPreliminaryBooking.data.meeting_id !== 'undefined'){
                    context.commit('set_idMeeting', res_setPreliminaryBooking.data.meeting_id);
                    return res_setPreliminaryBooking.data.meeting_id;
                } else {
                    if(typeof res_setPreliminaryBooking.data.error !== 'undefined'){
                        return {"error":res_setPreliminaryBooking.data.error,"description":res_setPreliminaryBooking.data.description};
                    } else {
                        return false
                    }
                }
            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
        },
        set_confirm: async function(context, payload) {
        const setBooking = '/index.php';

        const dataReq = {
            entryPoint: 'booking',
            action: 'confirm',
            hash: payload.hash,
            meeting_id: payload.meeting_id,
            firstName: payload.firstName,
            lastName: payload.lastName,
            email: payload.email,
            phone: payload.phone,
            description: payload.description,
            date: payload.date,
            time: payload.time,
        }
            try {
                const request_setBooking = await axios.post(setBooking, QS.stringify(dataReq));
                if(typeof request_setBooking.id_meeting !== 'undefined'){
                    context.commit('set_idMeeting', request_setBooking.id_meeting);
                    return request_setBooking.id_meeting;
                } else {
                    return false
                }
            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
        },
        set_deleteWorkerHours: function(context) {
            context.commit('set_storeWorkedTime', null);
            console.log('change timezone-->', context.getters.storeWorkedTime);
        },
        set_backDelete: async function(context, payload) {
            const setBackDelete = '/index.php?entryPoint=booking&action=index&meeting_id=' + payload.idAppointment + '&hash=' + context.getters.hash;
            console.log('setBackDelete = ', setBackDelete);
            try {
                // eslint-disable-next-line no-unused-vars
                const res_backDelete = await axios.post(setBackDelete);
            } catch (e) {
                context.commit('setError', e, {root: true});
                throw e
            }
        }
    },
    getters: {
        visiblePage(state){
            return state.visiblePage;
        },
        timeZoneLead(state){
            return state.timeZoneLead;
        },
        timeZoneLeadBanner(state){
            return state.timeZoneLeadBanner;
        },
        timeZoneUser(state){
            return state.timeZoneUser;
        },
        hash(state){
            return state.hash;
        },
        firstNameUser: state => state.firstNameUser,

        lastNameUser: state => state.lastNameUser,

        pageTitle(state){
            return state.pageTitle;
        },
        pageDescription(state){
            return state.pageDescription;
        },
        faviconPath: state => state.faviconPath,

        pageName: state => state.pageName,

        workHours(state){
            return state.workHours;
        },
        arrBlockedDate(state){
            return state.arrBlockedDate;
        },
        breakDuration(state){
            return state.breakDuration;
        },
        blockXDaysToMeetings(state){
            return state.blockXDaysToMeetings;
        },
        meetingDuration: state => state.meetingDuration,

        storeWorkedTime(state){
            return state.storeWorkedTime;
        },
        dateBooking: state => state.dateBooking,

        idMeeting: state => state.idMeeting,

        descriptionMeeting: state => state.descriptionMeeting,
    },
});
